module.exports = __webpack_public_path__ + "media/images/emblems/Courtedoux.ch-03435ad1cfdc4bfee0283c95145a9eed.png";